import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../../components/sidebar";
import Header from "../../components/header";
import "../../assets/CSS/dashboard.css";
import "../../assets/CSS/forms.css";
import API_BASE_URL from "../../config";
import "../../assets/CSS/loader.css";

function Receive() {
  const navigate = useNavigate();
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [divisionQuery, setDivisionQuery] = useState("");
  const [rangeQuery, setRangeQuery] = useState("");
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [rangeOptions, setRangeOptions] = useState([]);
  const [subjectQuery, setSubjectQuery] = useState("");
  const [subjectOptions, setSubjectOptions] = useState([]);

  useEffect(() => {
    if (!divisionQuery) {
      setDivisionOptions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/division-options?query=${divisionQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setDivisionOptions(data.divisions.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [divisionQuery]);

  useEffect(() => {
    if (!rangeQuery) {
      setRangeOptions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/range-options?query=${rangeQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setRangeOptions(data.ranges.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [rangeQuery]);

  useEffect(() => {
    if (!subjectQuery) {
      setSubjectOptions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/subject-options?query=${subjectQuery}`)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          setSubjectOptions(data.subjects.map((d) => d.subject));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [subjectQuery]);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);

    try {
      const response = await fetch(API_BASE_URL + "/api/letter/receive", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Data added successfully");
        formRef.current.reset();
        setIsSubmitting(false);
        setLoader(false);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />
        <div id="form-content">
          <div id="form-header">
            <p>Letter Receive</p>
          </div>
          <hr />
          <form id="form" ref={formRef}>
            <div id="form-input">
              <label htmlFor="name">
                Division Name<span className="required">*</span>
              </label>
              <input
                type="text"
                name="division"
                id="division"
                placeholder="Select Project Division"
                list="division-options"
                value={divisionQuery}
                onChange={(e) => setDivisionQuery(e.target.value)}
                autoComplete="off"
                required
              />
              <datalist id="division-options">
                {divisionOptions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
            <div id="form-input">
              <label htmlFor="range">
                Range Name<span className="required">*</span>
              </label>
              <input
                type="text"
                name="range"
                id="range"
                placeholder="Select Project Range"
                list="range-options"
                value={rangeQuery}
                onChange={(e) => setRangeQuery(e.target.value)}
                autoComplete="off"
                required
              />
              <datalist id="range-options">
                {rangeOptions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
            <div id="form-input">
              <label htmlFor="letter-number">
                Letter Number<span className="required">*</span>
              </label>
              <input
                type="text"
                name="letter-number"
                id="letter-number"
                placeholder="Enter Letter Number"
                required
              />
            </div>
            <div id="form-input">
              <label htmlFor="letter-date">
                Letter Date<span className="required">*</span>
              </label>
              <input type="date" name="letter-date" id="letter-date" required />
            </div>
            <div id="form-input">
              <label htmlFor="subject">
                Subject<span className="required">*</span>
              </label>
              <input
                type="text"
                name="subject"
                id="subject"
                placeholder="Select Subject"
                required
                value={subjectQuery}
                onChange={(e) => setSubjectQuery(e.target.value)}
                autoComplete="off"
                list="subject-options"
              />
              <datalist id="subject-options">
                {subjectOptions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
            <div id="form-input">
              <label htmlFor="letter">
                Letter<span className="required">*</span>
              </label>
              <input
                type="file"
                accept=".pdf, .jpg, .jpeg, .png"
                name="letter"
                id="letter"
                required
                placeholder="Upload Letter"
              />
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              SUBMIT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Receive;
